import '@babel/polyfill';
import './polyfills';
import homePage from './pages/home';
import payments from './pages/payments';
import newsListingPage from './pages/news-listing';
import newsPostPage from './pages/news-post';
import aboutPage from './pages/about';
import productPage from './pages/product';
import contactPage from './pages/contact';
import careersPage from './pages/careers';
import cartPage from './pages/cart';
import checkoutPage from './pages/checkout';
import search from './components/search-new';
import nav from './components/nav';
import modals from './components/modals';
import accordions from './components/accordions';
import $ from 'jquery';
import fitty from 'fitty';
import objectFitImages from 'object-fit-images';
import flatpickr from "flatpickr";

/**
 * Functions to be called on all pages
 */
function callOnAllPages() {
	if (document.querySelector('.magnifying-glass')) {
		search();
	}

	if (document.querySelector('.header__nav') && !document.querySelector('.residential-waste')) {
		nav();
	}

	modals();
	accordions();
	objectFitImages();
	$('.sidebar-email').each(function () {
		fitty(this, {
			maxSize: 14
		});
	});

}

/**
 * Page specific functions to be called
 */
function callPageFunctions() {
	if (document.querySelector('.page--home')) return homePage();
	if (document.querySelector('.news-listing')) return newsListingPage();
	if (document.querySelector('.page--news-post')) return newsPostPage();
	if (document.querySelector('.page--about')) return aboutPage();
	if (document.querySelector('.page--contact')) return contactPage();
	if (document.querySelector('.page--careers')) return careersPage();
	if (document.querySelector('.woocommerce-cart')) return cartPage();
	if (document.querySelector('.woocommerce-checkout')) return checkoutPage();
    if (document.querySelector('.payments')) return payments();
    if (document.querySelector('body.single-product')) return productPage();
}


document.addEventListener('DOMContentLoaded', function init() {
	callOnAllPages();
	callPageFunctions();
});
